/** Resolve PeerJS ids for seated players in the current game room. */
export function resolveGameConnectPeers(peers, game, identity, bootstrapPeer = '') {
  const seatedPlayerIds = new Set(
    [game?.players?.white?.playerId, game?.players?.black?.playerId].filter(Boolean)
  );
  const peerIds = new Set();

  for (const peer of peers || []) {
    if (!peer?.peerId || peer.peerId === identity?.peerId) {
      continue;
    }
    const playerId = peer.metadata?.playerId;
    if (playerId && seatedPlayerIds.has(playerId)) {
      peerIds.add(peer.peerId);
    }
  }

  const trimmedBootstrap = String(bootstrapPeer || '').trim();
  if (trimmedBootstrap && trimmedBootstrap !== identity?.peerId) {
    peerIds.add(trimmedBootstrap);
  }

  return [...peerIds];
}

/**
 * Fanout set for moves / live state: seated players, spectators, and any
 * already-open PeerJS links. Rankings can lag; plies must not.
 */
export function resolveGameFanoutPeers({
  peers,
  game,
  identity,
  bootstrapPeer = '',
  openPeerIds = [],
  discoveredPeers = []
} = {}) {
  const peerIds = new Set(
    resolveGameConnectPeers(peers, game, identity, bootstrapPeer)
  );
  const selfId = identity?.peerId;

  for (const peer of peers || []) {
    if (!peer?.peerId || peer.peerId === selfId) {
      continue;
    }
    if (
      peer.metadata?.role === 'spectator'
      || (game?.id && peer.metadata?.gameId === game.id)
    ) {
      peerIds.add(peer.peerId);
    }
  }

  for (const peerId of openPeerIds || []) {
    if (peerId && peerId !== selfId) {
      peerIds.add(peerId);
    }
  }
  for (const peerId of discoveredPeers || []) {
    if (peerId && peerId !== selfId) {
      peerIds.add(peerId);
    }
  }

  return [...peerIds];
}

export function opponentPlayerId(game, identityPlayerId) {
  if (!game?.players?.white || !game?.players?.black) {
    return null;
  }
  if (game.players.white.playerId === identityPlayerId) {
    return game.players.black.playerId;
  }
  if (game.players.black.playerId === identityPlayerId) {
    return game.players.white.playerId;
  }
  return null;
}

export function hasBothVdfProofs(game, vdfProofs) {
  if (!game?.rated || !game.players?.white || !game.players?.black) {
    return true;
  }
  return Boolean(
    vdfProofs[game.players.white.playerId]
    && vdfProofs[game.players.black.playerId]
  );
}
